var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TableRender',{attrs:{"Service":_vm.Service,"searchFields":_vm.searchFields}},[_c('TableText',{attrs:{"prop":"name","label":"标识","width":200}}),_c('TableText',{attrs:{"prop":"display_name","label":"名称","width":200}}),_c('TableText',{attrs:{"prop":"value","label":"值","width":160}}),_c('TableAction',{attrs:{"buttons":[
    { name: '编辑' },
    { name: '删除' }
  ],"minWidth":160}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }